import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function Organizations() {
  const navigate = useNavigate();

  const columns = useMemo(() => [
    { field: 'orgName', headerName: 'Organization', minWidth: 180 },
    { field: 'ownerName', headerName: 'Owner' },
    { field: 'ownerEmail', headerName: 'Email', minWidth: 200 },
    { field: 'totalCompanies', headerName: 'Companies', filter: 'agNumberColumnFilter' },
    { field: 'connectedCompanies', headerName: 'Connected', filter: 'agNumberColumnFilter' },
    { field: 'totalUsers', headerName: 'Users', filter: 'agNumberColumnFilter' },
    { field: 'sourcePlatform', headerName: 'Source' },
    { field: 'createdAt', headerName: 'Created', valueFormatter: fmtDate },
    { field: 'lastActivity', headerName: 'Last Activity', valueFormatter: fmtDate },
    { field: 'pluginOpened', headerName: 'Plugin', valueGetter: (p) => p.data?.pluginOpened ? 'Yes' : 'No' },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getOrganizations({ page: 0, size: 10000 });
    return res.content || [];
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Organizations</h1>
      <AdminGrid
        columns={columns}
        fetchData={fetchData}
        onRowClick={(data) => navigate(`/admin/organizations/${data.orgId || data.id}`)}
      />
    </div>
  );
}
